import React from "react";

export default function Graph_ChartJS() {
  return (
    <div>
      <h1>Graph_ChartJS</h1>
      <p>This is the Graph_ChartJS component.</p>
    </div>
  );
}
